import { render } from "./table.vue?vue&type=template&id=785dd332"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"

import "./table.vue?vue&type=style&index=0&id=785dd332&lang=scss"

import exportComponent from "D:\\Development\\vue\\okraina.sbs.monitor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__